import { mapRange } from '@wix/wow-utils';
import { roundNumber } from '../../utils';
const POWER_TO_PULSE_OFFSET_MAP = {
  soft: 0,
  medium: 0.06,
  hard: 0.12
};
const SCALE_KEYFRAMES = [{
  keyframe: 27,
  scale: 0.96
}, {
  keyframe: 45,
  scale: 1
}, {
  keyframe: 72,
  scale: 0.93
}, {
  keyframe: 100,
  scale: 1
}];
export default function create(options) {
  const {
    power,
    intensity = 0
  } = options.namedEffect;
  const duration = options.duration || 0;
  const delay = options.delay || 0;
  const responsivePulseOffset = mapRange(0, 1, POWER_TO_PULSE_OFFSET_MAP.soft, POWER_TO_PULSE_OFFSET_MAP.hard, intensity);
  const pulseOffset = typeof power !== 'undefined' ? POWER_TO_PULSE_OFFSET_MAP[power] : responsivePulseOffset;
  const keyframes = SCALE_KEYFRAMES.map(_ref => {
    let {
      keyframe,
      scale
    } = _ref;
    return {
      offset: keyframe / 100 * (duration / (duration + delay)),
      scale: `${roundNumber(scale - (scale < 1 ? pulseOffset : 0))}`
    };
  });
  return [{
    ...options,
    delay: 0,
    // in ongoing with a delay, it starts right away in the playground -> just remove the delay and only worry about delay between iterations?
    duration: duration + delay,
    keyframes: [...keyframes, {
      offset: 1,
      scale: 1
    }]
  }];
  /*
   *
   * * @keyframes <name> {
   *   <duration / (duration + delay)> {
   *      scale: <scale - (scale < 1 ? pulseOffset : 0>
   *   }
   *  100% {
   *      scale: 1
   *   }
   * }
   *
   *
   * #target {
   *   animation: <name> <duration + delay> infinite;
   * }
   */
}
//# sourceMappingURL=Pulse.js.map